import { render, staticRenderFns } from "./VCalendar.vue?vue&type=template&id=420baa3b&scoped=true&"
import script from "./VCalendar.vue?vue&type=script&lang=js&"
export * from "./VCalendar.vue?vue&type=script&lang=js&"
import style0 from "./VCalendar.vue?vue&type=style&index=0&id=420baa3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420baa3b",
  null
  
)

export default component.exports